import {configureStore, combineReducers} from '@reduxjs/toolkit';
import appReducer from '../appSlice';
import frameworkReducer from '../components/Framework/frameworkSlice';
import cabviewReducer from '../features/Cabview/cabviewSlice';
import cropviewReducer from '../features/Cropview/cropviewSlice';
import zoneInfoReducer from '../features/Mapview/zoneInfoSlice';
import inspectionFormReducer from '../features/InspectionForm/inspectionFormSlice';
import breakdownFormReducer from '../features/BreakdownForm/breakdownFormSlice';
import shopviewReducer from '../features/Shopview/shopviewSlice';
import upcomingModalReducer from '../features/Shopview/Upcoming/upcomingModalSlice';
import scheduleModalReducer from '../features/Shopview/Schedule/scheduleModalSlice';
import historyModalReducer from '../features/Shopview/History/historyModalSlice';
import diagnosticsModalReducer from '../features/Shopview/Diagnostics/diagnosticsModalSlice';
import inspectionReportsModalReducer from '../features/Shopview/InspectionReports/inspectionReportsModalSlice';
import searchBarReducer from '../components/Topbar/searchBarSlice';
import vehicleInfoReducer from '../features/Settings/Assets/VehicleInfo/vehicleInfoSlice';
import settingsReducer from '../features/Settings/settingsSlice';
import dashboardReducer from '../features/Statsview/dashboardSlice';
import alertviewReducer from '../features/Alertview/alertviewSlice';
import chatReducer from '../features/Insights/chatSlice';
import laborReducer from '../features/Labor/laborSlice';
import reportBuilderReducer from '../features/ReportBuilder/reportBuilderSlice';

const combinedReducer = combineReducers({
  app: appReducer,
  framework: frameworkReducer,
  cabview: cabviewReducer,
  cropview: cropviewReducer,
  inspectionForm: inspectionFormReducer,
  breakdownForm: breakdownFormReducer,
  shopview: shopviewReducer,
  upcomingModal: upcomingModalReducer,
  scheduleModal: scheduleModalReducer,
  historyModal: historyModalReducer,
  diagnosticsModal: diagnosticsModalReducer,
  inspectionReportsModal: inspectionReportsModalReducer,
  searchBar: searchBarReducer,
  zoneinfo: zoneInfoReducer,
  vehicleinfo: vehicleInfoReducer,
  settings: settingsReducer,
  dashboard: dashboardReducer,
  alertview: alertviewReducer,
  chat: chatReducer,
    labor: laborReducer,
    reportBuilder: reportBuilderReducer,
});

const rootReducer = (state, action) => {
  // If receive action 'RESET', set store to initial state
  if (action.type === 'RESET') {
    state = undefined;
  }
  return combinedReducer(state, action);
};

export default configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: [
          'cropview.zoneAnalytics',
          'cropview.equipmentAnalytics',
          'cropview.idleHeatMapCache',
          'reportBuilder.present',
          'reportBuilder.past',
          'reportBuilder.future',
        ],
      },
    });
  },
});
